import React from 'react';

const CopyStylesEmpty = () => (
  <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <rect x="12.5" y="9.5" width="34" height="38" stroke="#3060AF" strokeOpacity="0.25" />
    <rect x="15.3857" y="12.5" width="13.1429" height="15.0769" stroke="#3060AF" strokeOpacity="0.25" />
    <rect x="15.3857" y="29.4231" width="13.1429" height="15.0769" stroke="#3060AF" strokeOpacity="0.25" />
    <rect x="30.4714" y="12.5" width="13.1429" height="15.0769" stroke="#3060AF" strokeOpacity="0.25" />
    <rect x="30.4714" y="29.4231" width="13.1429" height="15.0769" stroke="#3060AF" strokeOpacity="0.25" />
  </svg>
);
export default CopyStylesEmpty;
